import { inject, Injectable } from '@angular/core';
import { Category } from '../dto/category.model';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  httpClient = inject(HttpClient);

  getAll(): Observable<Category[]> {
    return this.httpClient.get<Category[]>(environment.apiUrl + '/categories');
  }
}
